import React from 'react';
import SuccessNotificationBanner from '@components/SuccessNotificationBanner';

import { LpaType } from '../../utils';
import LpaContact from './LpaContact';
import LpaUpload from './LpaUpload';
import {
  SuccessNotiPositionEnum,
  ShowSuccessNotificationType,
} from '../../../../../commons';
import { successMessage } from '../../../../utils';

interface LpaInformationProps {
  userId: string;
  lpa: LpaType;
  setLpa: React.Dispatch<React.SetStateAction<LpaType>>;
  lpaFromData: LpaType;
  onSaveInLpa: (e: any, position: SuccessNotiPositionEnum) => void;
  showSuccessNotification: ShowSuccessNotificationType;
}

const LpaInformation: React.FC<LpaInformationProps> = ({
  userId,
  lpa,
  setLpa,
  lpaFromData,
  onSaveInLpa,
  showSuccessNotification,
}) => {
  return (
    <div>
      <div className="govuk-form-group">
        <h1 className="govuk-label-wrapper">
          <label className="govuk-label govuk-label--l" htmlFor="lpa-location">
            The location of the LPA information
          </label>
        </h1>
        <textarea
          className="govuk-textarea"
          id="lpa-location"
          name="lpaLocation"
          rows={5}
          value={lpa.lpaInfo.lpaLocation}
          placeholder="The location of the LPA"
          onChange={e =>
            setLpa(prev => ({
              ...prev,
              lpaInfo: { ...prev.lpaInfo, lpaLocation: e.target.value },
            }))
          }
        />
      </div>
      <div className="govuk-form-group">
        <h1 className="govuk-label-wrapper">
          <label className="govuk-label govuk-label--l" htmlFor="lpa-deputies">
            The names of any appointed people or deputies
          </label>
        </h1>
        <div id="lpa-deputies-hint" className="govuk-hint">
          Add the names of of all the appointed people or deputies listed on the
          document
        </div>
        <textarea
          className="govuk-textarea"
          id="lpa-deputies"
          name="lpaDeputies"
          rows={5}
          placeholder="Add appointed people or deputies"
          aria-describedby="lpa-deputies-hint"
          value={lpa.lpaInfo.lpaDeputies}
          onChange={e =>
            setLpa(prev => ({
              ...prev,
              lpaInfo: { ...prev.lpaInfo, lpaDeputies: e.target.value },
            }))
          }
        />
      </div>
      <button
        type="submit"
        className="govuk-button"
        data-module="govuk-button"
        disabled={showSuccessNotification.btnLoading}
        onClick={e => onSaveInLpa(e, SuccessNotiPositionEnum.FIFTH)}
      >
        Save and continue
      </button>
      {showSuccessNotification.status &&
        showSuccessNotification.position === SuccessNotiPositionEnum.FIFTH && (
          <SuccessNotificationBanner
            title={successMessage.title}
            content={successMessage.content}
            duration={3000}
            noScrollToTop
          />
        )}
      <LpaContact lpa={lpa} setLpa={setLpa} lpaFromData={lpaFromData} />
      <LpaUpload
        userId={userId}
        lpa={lpa}
        setLpa={setLpa}
        lpaFromData={lpaFromData}
      />
    </div>
  );
};

export default LpaInformation;
